export function average(numbers: number[]): number {
    return Math.round(numbers.reduce((a, b) => a + b, 0) / numbers.length);
}

export function sum(numbers: number[]): number {
    return numbers.reduce((a, b) => (a += b ?? 0), 0);
}
